import { css } from '@emotion/react';
import { PaymentElement } from '@stripe/react-stripe-js';
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import { useTranslation } from '@frontend/i18n';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { ContentLoader, Heading, TextField } from '@frontend/design-system';
import { CardOnFileStripeContextValue } from '../../../widgets/card-on-file/context/card-on-file-stripe.context';

const styles = {
  verticalFlex: css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  }),
};

export type CardOnFileFormStripeProps = {
  setCardReadyToSubmit: CardOnFileStripeContextValue['setCardReadyToSubmit'];
  shouldShowLoading: boolean;
  nameFieldProps: CardOnFileStripeContextValue['nameFieldProps'];
  className?: string;
};
export const CardOnFileFormStripe = ({
  setCardReadyToSubmit,
  shouldShowLoading,
  nameFieldProps,
  className,
}: CardOnFileFormStripeProps) => {
  const { t } = useTranslation('payments');

  const handleCardChange = (event: StripePaymentElementChangeEvent) => {
    setCardReadyToSubmit(event.complete);
  };

  return (
    <div className={classNames('card-on-file', className)} css={styles.verticalFlex}>
      <ContentLoader show={shouldShowLoading} />
      <Heading className='add-card-form__header' level={2}>
        {t('Save Card on File')}
      </Heading>
      <TextField name='cardholderName' label={t('Cardholder Name')} hasNonFloatingLabel {...nameFieldProps} />
      <PaymentElement onChange={handleCardChange} />
    </div>
  );
};
